import React, { useState, useEffect  } from "react";
import {
  Button,
  Box,
  Typography,
  Paper,
  Grid,
  Modal, useMediaQuery,
} from '@mui/material';
import { useNavigate } from "react-router-dom";
import BottomImage from "../../components/LoginPages/bottomimage";
import HeaderApp from "../../components/LoginPages/header";
import "./style.css";

const RecoveryPassword = ({newRecoveryPasswordOpen, setNewRecoveryPasswordOpen, setLoginOpen}) => {
  const [email, setEmail] = useState(localStorage.getItem("email") || "");
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const isMediumScreen = useMediaQuery(theme => theme.breakpoints.between('sm', 'md'));
  const isLargeScreen = useMediaQuery(theme => theme.breakpoints.up('md'));


  useEffect(() => {
      setEmail(localStorage.getItem("email") || "");
  }, []);

  const handleSubmit = () => {
    // navigate("/login");
    setNewRecoveryPasswordOpen(false);
    setLoginOpen(true);
  };

  return (
    <>
      <Modal open={newRecoveryPasswordOpen} onClose={() => setNewRecoveryPasswordOpen(false)} sx={{ backdropFilter: "blur(5px)", background: "#1D1D1D99"}} slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "transparent",
          },
        },
      }}>
        <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: isSmallScreen ? "90%" : "500px", maxHeight: "600px", backgroundColor: "#fff", boxShadow: 24, overflow: "auto", borderRadius: "20px", }}>
          <Paper elevation={3} sx={{ padding: "1.6em 3em", display: 'flex', flexDirection: 'column', alignItems: 'center', background:'#fffff', position: 'relative', zIndex: 1, borderRadius: "15px", boxShadow: "rgba(0, 0, 0, 0.1) 0px 7px 49px 0px" }}>
            <Typography sx={{ textAlign: "center", fontWeight: 400, fontSize: '16px', color: "#565555", lineHeight: 2 }}>
                    {/* Time to rescue your account! Your recovery link is chillin’ in {email} . */}
                    Password changed successfully! Please log in using your new password.
            </Typography>
            <Box component="img" src={`${process.env.PUBLIC_URL}/images/mail.gif`} alt="mail" sx={{ height: 120 }} />
            <Button
              variant="contained"
              sx={{
                width: '100%',
                height: 45,
                color: "#fff",
                background: "#185CB7",
                textTransform: "none",
                fontSize: "16px",
                borderRadius: "10px",
                fontWeight: "600",
                "&:hover": { background: "#185CB7" },
              }}
              onClick={handleSubmit}
            >
              Login
            </Button>
          </Paper>
        </Box>
      </Modal>
    </>
  );
};

export default RecoveryPassword;
